import urlParameters from './urlParameters'
import brands from './brands'
import templates from './templates'
import config from './config'

export default {
  urlParameters,
  brands,
  templates,
  config
}



// WEBPACK FOOTER //
// ./src/library/cdu/index.js